import api from "./axios";

/**
 * Create a new submission
 * @param {string} campaignId - Campaign ID
 * @param {string} platform - Platform (instagram, youtube, tiktok, facebook)
 * @param {string} videoLink - Link to the video
 * @returns {Promise} API response
 */
export const createSubmission = async (campaignId, platform, videoLink) => {
  const response = await api.post("/submissions", {
    campaignId,
    platform,
    videoLink,
  });
  return response.data;
};

/**
 * Get submissions for a campaign
 * @param {string} campaignId - Campaign ID
 * @returns {Promise} API response
 */
export const getSubmissionsByCampaign = async (campaignId) => {
  const response = await api.get(`/submissions/campaign/${campaignId}`);
  return response.data;
};

/**
 * Get submissions for a mint space
 * @param {string} mintSpaceId - Mint Space ID
 * @returns {Promise} API response
 */
export const getSubmissionsByMintSpace = async (mintSpaceId) => {
  const response = await api.get(`/submissions/mintspace/${mintSpaceId}`);
  return response.data;
};

/**
 * Update submission status (approve/reject)
 * @param {string} submissionId - Submission ID
 * @param {string} status - Status (approved, rejected)
 * @param {string} notes - Optional notes
 * @returns {Promise} API response
 */
export const updateSubmissionStatus = async (submissionId, status, notes = "") => {
  const response = await api.patch(`/submissions/${submissionId}`, {
    status,
    notes,
  });
  return response.data;
};
